import { useState } from "react";

const faqs = [
  {
    question: "À quelle vitesse intervenez-vous à Schiltigheim ?",
    answer:
      "Schiltigheim est à quelques minutes de notre atelier. Pour une fenêtre bloquée ou une poignée cassée, nous pouvons souvent intervenir le jour même. Les réparations programmées sont fixées sous 24 heures. Le technicien arrive avec son stock de pièces courantes, diagnostique gratuitement et vous remet un devis avant toute intervention.",
  },
  {
    question: "Le diagnostic à domicile est-il vraiment gratuit ?",
    answer:
      "Oui, le diagnostic est totalement gratuit et sans engagement. Le technicien examine votre fenêtre, identifie la panne et vous explique la réparation nécessaire. Si la pièce n'est pas en stock, il la commande et revient en 48 heures maximum. Vous ne payez qu'après réparation, et seulement si vous acceptez le devis.",
  },
  {
    question: "Vos techniciens montent-ils dans les immeubles de Schiltigheim ?",
    answer:
      "Bien sûr. Schiltigheim compte de nombreux immeubles collectifs de plusieurs étages. Nos techniciens sont équipés pour intervenir dans tous les contextes : appartements, maisons, résidences, logements sociaux. Nous réparons toutes les marques de quincaillerie — Ferco, GU, Roto, Maco, Siegenia, Winkhaus, Aubi, Cadiou — et chaque pièce remplacée est garantie 10 ans.",
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="bg-white py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-[1280px] mx-auto">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-serif font-bold text-plum-dark mb-8 md:mb-10">
            Questions fréquentes — Schiltigheim
          </h2>
          <div className="space-y-3 md:space-y-4">
            {faqs.map((faq, i) => {
              const isOpen = openIndex === i;
              return (
                <div
                  key={i}
                  className="bg-white rounded-2xl border border-rose-100 overflow-hidden"
                >
                  <button
                    onClick={() => setOpenIndex(isOpen ? null : i)}
                    className="w-full flex items-center justify-between gap-4 px-5 py-4 md:px-6 md:py-5 text-left"
                  >
                    <span className="font-semibold text-base md:text-lg text-plum-dark">
                      {faq.question}
                    </span>
                    <div className="w-8 h-8 rounded-full bg-rose-50 flex items-center justify-center shrink-0">
                      <i className={`ri-${isOpen ? "subtract" : "add"}-line text-plum`} />
                    </div>
                  </button>
                  {isOpen && (
                    <div className="px-5 pb-5 md:px-6 md:pb-6">
                      <p className="text-sm md:text-base text-plum-dark/80 leading-relaxed">
                        {faq.answer}
                      </p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}